import promise from 'bluebird'
import {marketingService} from "../_services";
import { marketingConstants } from '../_constants';


export const marketingAction = {
    createMarketingSetting,
    getSettings,
    getMarketingSetting,
    updateSetting,
    marketingUpdateSettingData,
    addReminder,
    removeReminder,
    reminderTimeType,
    updateMarketingSetting,
    setSalonMarketingSetting,
    marketingSettingNavigation,
    uploadReminderImage,
    uploadEmailBodyImage,
    deleteEmailBodyImage,
    // Campaign actions
    createCampaign,
    updateCampaign,
    sendCampaign,
    getCampaigns,
    getCampaignDetails,
    getCampaignRecipients,
    deleteCampaign,
    estimateCost,
    getAudienceSegments,
    // Analytics actions
    getAnalyticsOverview,
    getAutomationStats,
    getClientCommunications,
    getEmailTemplatePreview,
    getInsights,
    exportAnalytics,
    // Content actions
    getSalonReviews
};

/************************************** Marketing Action ******************************************************/

function createMarketingSetting() {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            marketingService.createMarketingSetting()
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}

function addReminder(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            marketingService.addReminder(params)
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}


function updateSetting(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            marketingService.updateSetting(params)
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}

function removeReminder(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            marketingService.removeReminder(params)
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}


function getSettings() {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            marketingService.getSettings()
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}


function getMarketingSetting() {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            marketingService.getMarketingSetting()
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}


function updateMarketingSetting(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            marketingService.updateMarketingSetting(params)
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}


function marketingUpdateSettingData(data) {
    return function (dispatch) {
        dispatch({ type: marketingConstants.UPDATE_MARKETING_DATA, data })
    }
};


function setSalonMarketingSetting(data) {
    return function (dispatch) {
        dispatch({ type: marketingConstants.SALON_MARKETING_SETTING, data })
    }
};

function marketingSettingNavigation(data) {
    return function (dispatch) {
        dispatch({ type: marketingConstants.NAVIGATION_MARKETING_SETTING, data })
    }
};




function reminderTimeType(type){
    switch (type) {
        case 1:
            return 'minutes';
        case 2:
            return 'hours';
        case 3:
            return 'days';
        case 4:
            return 'weeks';
        case 5:
            return 'months';
        default:
            return ''; 
    }
  }
  
  function uploadReminderImage(imageFile) {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.uploadReminderImage(imageFile)
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }
  
  function uploadEmailBodyImage(imageFile) {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.uploadEmailBodyImage(imageFile)
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }
  
  function deleteEmailBodyImage(imageUrl) {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.deleteEmailBodyImage(imageUrl)
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }

  /************************************** Campaign Actions ******************************************************/

  function createCampaign(params) {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.createCampaign(params)
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }

  function updateCampaign(params) {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.updateCampaign(params)
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }

  function sendCampaign(params) {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.sendCampaign(params)
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }

  function getCampaigns(params) {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.getCampaigns(params)
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }

  function getCampaignDetails(params) {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.getCampaignDetails(params)
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }

  function getCampaignRecipients(params) {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.getCampaignRecipients(params)
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }

  function deleteCampaign(params) {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.deleteCampaign(params)
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }

  function estimateCost(params) {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.estimateCost(params)
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }

  function getAudienceSegments() {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.getAudienceSegments()
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }

  /************************************** Analytics Actions ******************************************************/

  function getAnalyticsOverview(params) {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.getAnalyticsOverview(params)
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }

  function getEmailTemplatePreview(params) {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.getEmailTemplatePreview(params)
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }

  function getClientCommunications(params) {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.getClientCommunications(params)
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }

  function getAutomationStats(params) {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.getAutomationStats(params)
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }

  function getInsights() {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.getInsights()
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }

  function exportAnalytics(params) {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.exportAnalytics(params)
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }

  function getSalonReviews() {
      return function (dispatch) {
          return new promise(function (resolve, reject) {
              marketingService.getSalonReviews()
                  .then(response => {
                      resolve(response);
                  })
                  .catch((err) => {
                      reject(err);
                  })
          })
      };
  }

